import mitt, { type Emitter as Emitt, type Handler } from 'mitt'

import type { DuplicateContext, RequestError } from './types'

/**
 * Event types for the emitter
 */
export interface Events {
  error: RequestError
  warn: RequestError
  duplicate: DuplicateContext
  [key: string | symbol]: any
}

export default class Emitter {
  #mitt: Emitt<Events>

  constructor() {
    this.#mitt = mitt<Events>()
  }

  on<T extends keyof Events>(t: T, handler: Handler<Events[T]>): void {
    this.#mitt.on<T>(t, handler)
  }

  emit<T extends keyof Events>(t: T, evt: Events[T]): void {
    this.#mitt.emit<T>(t, evt)
  }
}
